/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON to CSV`)
};

const es_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON a CSV`)
};

const de_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON zu CSV`)
};

const nl_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON naar CSV`)
};

const fr_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON en CSV`)
};

const it_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON a CSV`)
};

const pt_br2_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON para CSV`)
};

const pt_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON para CSV`)
};

const ja_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON から CSV へ`)
};

const zh_cj_mode_j2c = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 转 CSV`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_mode_j2c = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_mode_j2c(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_mode_j2c", locale)
	if (locale === "en") return en_cj_mode_j2c(inputs)
	if (locale === "es") return es_cj_mode_j2c(inputs)
	if (locale === "de") return de_cj_mode_j2c(inputs)
	if (locale === "nl") return nl_cj_mode_j2c(inputs)
	if (locale === "fr") return fr_cj_mode_j2c(inputs)
	if (locale === "it") return it_cj_mode_j2c(inputs)
	if (locale === "pt-BR") return pt_br2_cj_mode_j2c(inputs)
	if (locale === "pt") return pt_cj_mode_j2c(inputs)
	if (locale === "ja") return ja_cj_mode_j2c(inputs)
	return zh_cj_mode_j2c(inputs)
};